<template lang="pug">
  tr.row
    td.col.blank
    td.col(v-for="v in columns", v-if="displayedColumns.includes(v.key)", :class="v.key")
      template(v-if="v.url")
        a(:href="corporation[v.key]" target="_blank" rel="noopener noreferrer") {{ corporation[v.key] }}
      template(v-else-if="v.multiple")
        span(v-for="c in corporation[v.key]")
          | {{ c }}
          br
      template(v-else)
        span.only-sp(v-if="v.spLabel") {{ v.spLabel }}
        a(v-if="v.detail", @click="openDetailPage") {{ corporation[v.key] }}
        span(v-else) {{ corporation[v.key] }}
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: ['corporation'],
    computed: {
      ...mapState({
        columns: state => state.corporationTableConfiguration.columns,
        displayedColumns: state => state.corporationTableConfiguration.displayedColumns,
      }),
    },
    methods: {
      openDetailPage (e) {
        e.stopPropagation()
        this.$router.push({ name: 'CorporationDetail', query: { id: this.corporation.id } })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/CorporationTableRow.vue